module.exports = __webpack_public_path__ + "static/media/Maractus_gaussian2.fa09427e.png";